export enum VisibilityLevel {
  visibleSelection = 0,
  visibleDetection = 5,
  hiddenDetection = 10,
  hiddenDetectionCategory = 20,
  hiddenDetectionDeleted = 35,
  hiddenSelection = 40,
}

export const stringForVisibility = (visibility?: VisibilityLevel) => {
  const map: { [key in VisibilityLevel]: string } = {
    '0': 'visible',
    '5': 'visible (auto)',
    '10': 'hidden (auto)',
    '20': 'hidden (category)',
    '35': 'deleted',
    '40': 'hidden',
  };
  const level = visibility !== undefined ? visibility : VisibilityLevel.visibleDetection;
  return map[level];
};

// VisibilityFilterOption is simplified and for filtering options. VisibilityLevel is the property on model objects

export enum VisibilityFilterOption {
  none = 'none',
  visible = 'visible',
  hidden = 'hidden',
}

export const stringForVisibilityFilterOption = (visibilityFilterOption: VisibilityFilterOption) => {
  switch (visibilityFilterOption) {
    case VisibilityFilterOption.none:
      return 'None';
    case VisibilityFilterOption.hidden:
      return 'Hidden';
    case VisibilityFilterOption.visible:
      return 'Visible';
  }
  // skipcq JS-0378
  throw new Error(`Unknown option ${visibilityFilterOption}`);
};
